import React, { useEffect, useState } from 'react'
import { ForwardedTextInput } from '../../../components/DesignSystem'
import { useAppSelector } from '../../../state/hooks'

type CutomTipInputProps = {
	setCustomTip: (value: number) => void
	prices: { subTotal: number; discount: number; tip: number }
	onFocus: () => void
	presetRadioOn: boolean
}

const CustomTipInput = React.forwardRef<any, CutomTipInputProps>(
	({ setCustomTip, prices, onFocus, presetRadioOn }, ref) => {
		const { selectedTip } = useAppSelector(state => state.checkout)
		const isCustomTipSelected = selectedTip === 9999

		const [val, setVal] = useState('')

		useEffect(() => {
			if (!isCustomTipSelected || presetRadioOn) {
				setVal('')
			}
		}, [isCustomTipSelected, presetRadioOn])

		return (
			<ForwardedTextInput
				size="large"
				ref={ref}
				prefix="$"
				placeholder={val === '' ? '0.00' : prices.tip.toFixed(2)}
				keyboardType="decimal-pad"
				value={val}
				maxNumber={999999.99}
				onChangeText={num => {
					// Remove any non-numeric characters except decimal point
					const formattedNum = num.replace(/[^0-9.]/g, '')

					// Check if there's more than one decimal point
					if ((formattedNum.match(/\./g) || []).length <= 1) {
						setVal(formattedNum)
						// Only parse to float if the string is not empty and not just a period
						if (formattedNum && formattedNum !== '.') {
							setCustomTip(parseFloat(formattedNum))
						} else {
							setCustomTip(0)
						}
					}
				}}
				onFocus={() => {
					onFocus()
					setCustomTip(0)
					setVal('')
				}}
				onBlur={() => {
					if (val === '' || isNaN(Number(val))) {
						setVal('0')
						setCustomTip(0)
					} else {
						const formattedValue = parseFloat(val).toFixed(2)
						setVal(formattedValue)
						setCustomTip(parseFloat(formattedValue))
					}
				}}
			/>
		)
	}
)

CustomTipInput.displayName = 'CustomTipInput'

export default CustomTipInput
